import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vh-100 d-flex flex-column" }
const _hoisted_2 = { class: "row g-0 flex-grow" }
const _hoisted_3 = { class: "flex-grow-1 ps-2 pe-2" }
const _hoisted_4 = { class: "sidebar-container col-12 col-xl-9 d-flex flex-column" }
const _hoisted_5 = { class: "flex-grow-1 d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardStartNavbar = _resolveComponent("DashboardStartNavbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(`${_ctx.header_type}-header`))),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["sidebar-container col-12 col-xl-3 border-end border-mobile-none border-warning d-flex flex-column", _ctx.theme == 'light' ? 'bg-secondary' : 'bg-primary'])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DashboardStartNavbar, {
            navs: _ctx.navs,
            active: _ctx.active,
            onChangeTheme: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeTheme', $event))),
            onChangeActive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event))
          }, null, 8, ["navs", "active"])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view, {
            onChangeNavs: _ctx.changeNavs,
            active: _ctx.active
          }, null, 8, ["onChangeNavs", "active"])
        ])
      ])
    ])
  ]))
}